const Menu = [

  {
    header: 'Apps'
  },
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
  },
  {
    title: 'Calendar',
    group: 'apps',
    icon: 'calendar_today',
    name: 'calendarview',
  },
  {
    title: 'Task',
    group: 'apps',
    icon: 'tune',
    name: 'Task',
  },
  // {
  //   title: 'Coversation',
  //   group: 'apps',
  //   icon: 'tune',
  //   name: 'Coversation',
  // },
  {
    title: 'Documents/Files',
    group: 'apps',
    name: 'Media',
    icon: 'cloud_upload',
  },
  {
    title: 'Contacts',
    group: 'apps',
    icon: 'contacts',
    name: 'Contact',
  },
  {
    title: 'DMS',
    //  group: 'settings',  
    group: 'dmssettings',
    component: 'dmsapp',
    icon: 'present_to_all',
    color: 'blue darken-2',
    items: [{
        title: 'Personal Folder',
        group: 'dmssettings',
        component: 'dmsapp/PersonalFolder',
        name: 'PersonalFolder',
      },
      {
        title: 'Public Folder',
        group: 'dmssettings',
        component: 'dmsapp/PublicFolder',
        name: 'PublicFolder',
      },
      {
        title: 'Administration',
        group: 'dmssettings',
        component: 'dmsapp/Administration',
        name: 'Administration',
      },
      {
        title: 'Document Profile',
        group: 'dmssettings',
        component: 'dmsapp/DocumentProfile',
        name: 'DocumentProfile',
      },
      {
        title: 'Access Rights',
        group: 'dmssettings',
        component: 'dmsapp/AccessRights',
        name: 'AccessRights',
      },
      // {
      //   title: 'Audit Trail',
      //   group: 'dmssettings',
      //   component: 'dmsapp/AuditTrail',
      //   name: 'AuditTrail',
      // },
    ]
  },
  {
    title: 'General Functions',
    //  group: 'settings',  
    group: 'generalitemssettings',
    component: 'generalitemsapp',
    icon: 'present_to_all',
    color: 'blue darken-2',
    items: [{
        title: 'New Document',
        group: 'generalitemssettings',
        component: 'generalitemsapp/NewDocument',
        name: 'NewDocument',
      },
      {
        title: 'New Folder',
        group: 'generalitemssettings',
        component: 'generalitemsapp/NewFolder',
        name: 'NewFolder',
      },
      {
        title: 'New Shortcut',
        group: 'generalitemssettings',
        component: 'generalitemsapp/ShortCut',
        name: 'ShortCut',
      },
      {
        title: 'New Compound Doc.',
        group: 'generalitemssettings',
        component: 'generalitemsapp/NewCompoundDoc',
        name: 'NewCompoundDoc',
      },
    ]
  },
  {
    header: 'Masters'
  },

  {
    title: 'Task Masters',
    //  group: 'settings',  
    group: 'tasksettings',
    component: 'taskapp',
    icon: 'settings_applications',
    items: [{
        title: 'Projects',
        group: 'tasksettings',
        component: 'taskapp/Projects',
        name: 'Project',
      },
      {
        title: 'Team',
        group: 'tasksettings',
        component: 'taskapp/Team',
        name: 'Team',
      },
      {
        title: 'Tags',
        group: 'tasksettings',
        component: 'taskapp/Tag',
        name: 'Tag',
      },
    ]
  },
  {
    title: 'Scrap Masters',
    //  group: 'settings',  
    group: 'scrapsettings',
    component: 'scrapapp',
    icon: 'build',
    items: [{
      name: 'plasticbag',
      title: 'Plastic Bag',
      component: 'app/plasticbag'
    }, {
      name: 'blisterType',
      title: 'Scrap Code',
      component: 'app/blisterType'
    }]
  },
  {
    title: 'Calendar Master',
    //  group: 'settings',  
    group: 'appsettings',
    component: 'app',
    icon: 'settings',
    items: [{
        name: 'country',
        title: 'Country',
        component: 'app/country'
      },
      {
        name: 'state',
        title: 'State',
        component: 'app/state'
      },
      {
        name: 'holiday',
        title: 'Holidays',
        component: 'app/holiday'
      },
      {
        name: 'shift',
        title: 'Shifts',
        component: 'app/shift'
      },

    ]
  },
  {
    header: 'Calendar Module'
  },
  {
    title: 'Calendar Settings',
    //  group: 'settings',  
    group: 'calendarsettings',
    component: 'calendar',
    icon: 'date_range',
    items: [

      {
        name: 'holiday',
        title: 'Holidays',
        component: 'calendar/holiday'
      },


      {
        name: 'promtuevent',
        title: 'Company Event',
        component: 'calendar/companyevent'
      },

      {
        name: 'workday',
        title: 'Work Day',
        component: 'calendar/workday'
      },
    ]
  },

  {
    header: 'Scrap Module'
  },
  {
    title: 'Scrap',
    //  group: 'settings',  
    group: 'scrap',
    component: 'scarps',
    icon: 'speaker_notes_off',
    items: [{
        name: 'scrapentry',
        title: 'Blister Scrap Entry',
        component: 'scrap/scrapentry'

      },
      {
        name: 'allowablescrap',
        title: 'Blister Master',
        component: 'scrap/allowablescrap'
      },
    ]
  },
  {
    title: 'Signout',
    group: 'signout',
    icon: 'settings_power',
    name: 'SignOut',
  },
  {
    header: '--------'
  },
];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;


// WEBPACK FOOTER //
// ./src/api/menu.js